import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { get } from "../../lib/request"
import { normalizeInboxHealthStats } from "../../lib/utils/inboxHealthReport"
import {
  beginPulseFetch,
  isStalePulseFetch,
} from "../../lib/utils/pulseApiRows"
import { skipIfClientLoaded } from "../utils/fetchDedupe"

/**
 * GET /api/v1/report/messages/clients/{clientId}/daily/stats
 */
export const fetchInboxHealth = createAsyncThunk(
  "inboxHealth/fetch",
  async ({ clientId } = {}, { rejectWithValue }) => {
    try {
      if (clientId == null || clientId === "") {
        return rejectWithValue("clientId is required")
      }

      const data = await get(`report/messages/clients/${clientId}/daily/stats`)

      return {
        stats: normalizeInboxHealthStats(data),
        clientId: String(clientId),
      }
    } catch (err) {
      return rejectWithValue(err?.message || "Failed to fetch inbox health")
    }
  },
  {
    condition: (arg, { getState }) => {
      return !skipIfClientLoaded(getState().inboxHealth, arg?.clientId)
    },
  },
)

const initialState = {
  stats: null,
  rows: [],
  status: "idle",
  error: null,
  requestedClientId: null,
  fetchedClientId: null,
  previousDate: null,
}

const inboxHealthSlice = createSlice({
  name: "inboxHealth",
  initialState,
  reducers: {
    clearInboxHealth: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInboxHealth.pending, (state, action) => {
        beginPulseFetch(state, action)
        state.stats = null
      })
      .addCase(fetchInboxHealth.fulfilled, (state, action) => {
        if (isStalePulseFetch(action, state)) return
        state.status = "succeeded"
        state.stats = action.payload?.stats ?? normalizeInboxHealthStats(null)
        state.rows = []
        state.fetchedClientId = action.payload?.clientId ?? null
        state.previousDate = null
      })
      .addCase(fetchInboxHealth.rejected, (state, action) => {
        if (isStalePulseFetch(action, state)) return
        state.status = "failed"
        state.error = action.payload ?? "Failed to fetch inbox health"
        state.stats = null
        state.rows = []
        state.fetchedClientId = state.requestedClientId
      })
  },
})

export const { clearInboxHealth } = inboxHealthSlice.actions
export default inboxHealthSlice.reducer
